import { render, staticRenderFns } from "./DeliveryTowerFixPrice.vue?vue&type=template&id=7690f7a2"
import script from "./DeliveryTowerFixPrice.vue?vue&type=script&lang=js"
export * from "./DeliveryTowerFixPrice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports